import React, { useState, useEffect } from "react";
import { Row, Button, Spinner, Col } from "react-bootstrap";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useTranslation } from "react-i18next";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { useDispatch } from "react-redux";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { updateComment } from "../../redux/actions/tasks";
import configVars from "../../config";

const EditComment = ({
  show,
  handleClose,
  selectedComment,
  color,
  tasklist_id,
  task_id,
  handleUpdateComment,
  taskType,
}) => {
  const dispatch = useDispatch();
  const [translation] = useTranslation("translations");
  const [loading, setLoading] = useState(null);
  const [comment, setComment] = useState(null);
  const [commentContent, setCommentContent] = useState(null);

  useEffect(() => {
    if (selectedComment) {
      let _content = null;
      if (selectedComment?.comment_content) {
        _content = selectedComment?.comment_content;
      }

      if (_content) {
        const contentBlock1 = htmlToDraft(_content);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setComment(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setCommentContent(_contentState);
        }
      }
    }
  }, [selectedComment, show]);

  const handleCommentEdit = async () => {
    try {
      setLoading(true);
      let commentObj = {};

      if (
        selectedComment?.comment_parent &&
        selectedComment?.comment_parent !== "0"
      ) {
        commentObj = {
          task_id: task_id,
          comment_id: selectedComment?.comment_id,
          comment: draftToHtml(commentContent),
          comment_parent: selectedComment?.comment_parent,
        };
      } else {
        commentObj = {
          task_id: task_id,

          comment_id: selectedComment?.comment_id,
          comment: draftToHtml(commentContent),
        };
      }

      let _comment = await dispatch(
        updateComment({
          comment: commentObj,
          taskId: task_id,
          listId: tasklist_id,
          parent: selectedComment?.comment_parent,
          taskType: taskType,
        })
      );

      if (_comment.status !== "error") {
        handleUpdateComment(_comment.data);
      }

      handleClose();

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }

    setComment(null);
    setCommentContent(null);
  };

  return (
    <div id="comment-editor">
      <Row className="mt-3">
        <Col lg="12">
          <Editor
            toolbar={configVars?.wysiwygToolbarOptions}
            editorState={comment}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editor-wrapper"
            onEditorStateChange={(e) => setComment(e)}
            onChange={(e) => setCommentContent(e)}
            placeholder={translation("task_forms.replies.placeholder")}
          />
          <div className="d-flex justify-content-end">
            <Button
              variant={`${color} text-white rounded`}
              className="m-2"
              disabled={loading}
              size="sm"
              onClick={handleCommentEdit}
            >
              {loading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{ color: "#fff" }}
                />
              ) : (
                translation("buttons.update")
              )}
            </Button>
            <Button
              variant={`${color} text-white rounded`}
              className="m-2"
              disabled={loading}
              size="sm"
              onClick={handleClose}
            >
              {translation("buttons.cancel")}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default EditComment;